<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import Errors from "../../Errors.svelte";
  import Label from "../Label.svelte";

  const dispatch = createEventDispatcher();

  export let errors: string[] = [];
  export let disabled: boolean = false;
  export let required: boolean = false;
  export let small: boolean = false;
  export let hours: number = 0;
  export let minutes: number = 0;
  export let name: string = "";

  $: displayName = required && name != "" ? name + " *" : name;

  function onKeyDown(event: KeyboardEvent) {
    if (event.keyCode == 13) {
      event.preventDefault();
      dispatch("enter", event);
    } else {
      dispatch("keydown", event);
    }
  }

  function onBlur(event: Event) {
    dispatch("blur", event);
  }
</script>

<div>
  {#if name != ""}
    <Label>
      {displayName}
    </Label>
  {/if}

  <p class="control">
    <input
      class="input input-ctr-time"
      class:is-danger={required && hours == null}
      class:is-small={small}
      class:input-ctr-disabled={disabled}
      bind:value={hours}
      on:keydown={onKeyDown}
      on:blur={onBlur}
      placeholder="hh"
      {disabled}
      {required}
      type="number"
      min={0}
    />

    <span class="input-ctr-sep">:</span>

    <input
      class="input input-ctr-time"
      class:is-danger={required && minutes == null}
      class:is-small={small}
      class:input-ctr-disabled={disabled}
      bind:value={minutes}
      on:keydown={onKeyDown}
      on:blur={onBlur}
      placeholder="mm"
      {disabled}
      {required}
      type="number"
      min={0}
      max={59}
    />
  </p>

  <Errors {errors} prefix={name} />
</div>

<style>
  .input-ctr-disabled {
    border-color: #dbdbdb;
  }

  .input-ctr-time {
    width: 80px;
    text-align: center;
  }

  .input-ctr-sep {
    font-size: 1.5rem;
    padding: 0 5px;
  }
</style>
